import { OdcNetwork } from "../../../../ViewModel/OdcNetwork";
import { EditProjectContextProps } from "../../../EditProjectContext";

export function addOdcToRoute(
  ftlRouteId: number,
  items: Array<OdcNetwork>,
  EditProjectContext: EditProjectContextProps
) {
  const { project, setProject } = EditProjectContext;
  const updateFtlRoutes = project?.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteId !== ftlRouteId || !ftlRoute.Odcs) {
      return ftlRoute;
    }
    return {
      ...ftlRoute,
      Odcs: [...ftlRoute.Odcs, ...items],
    };
  });

  setProject({
    ...project,
    FTLRoutes: updateFtlRoutes,
  });
}
